"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApIcon = exports.iconSizes = void 0;
var React = require("react");
var theme_1 = require("../../utils/theme");
var paths_1 = require("./paths");
var styles_1 = require("./styles");
/* tslint:disable */
exports.iconSizes = {
    sm: '24',
    lg: '32',
    viewBox: '24',
};
/* tslint:enable */
exports.ApIcon = function (_a) {
    var className = _a.className, iconName = _a.iconName, iconSize = _a.iconSize, iconColor = _a.iconColor, material = _a.material, _b = _a.outlined, outlined = _b === void 0 ? true : _b, twoTone = _a.twoTone, round = _a.round, sharp = _a.sharp, props = __rest(_a, ["className", "iconName", "iconSize", "iconColor", "material", "outlined", "twoTone", "round", "sharp"]);
    if (!iconName) {
        throw new Error('iconName was not specified');
    }
    var getIconSize = function (value) {
        return exports.iconSizes[value] ? exports.iconSizes[value] : value;
    };
    if (material) {
        if ([outlined, twoTone, round, sharp].filter(function (f) { return f; }).length > 1) {
            throw new Error('You can use only one set of icons: outlined, twoTone, round, sharp. Filled is default');
        }
        var materialClass = "material-icons" + (outlined ? '-outlined' : '') + (twoTone ? '-two-tone' : '') + (round ? '-round' : '') + (sharp ? '-sharp' : '');
        return (React.createElement(styles_1.MaterialIcon, { "aria-label": iconName, className: materialClass + " " + (className ? className : ''), iconSize: iconSize ? iconSize : 'inherit' }, iconName));
    }
    if (!paths_1.paths[iconName]) {
        throw new Error("\n      We can't find '" + iconName + "' icon in a list of custom icons.\n      Add 'material' prop if you want to use one of Material UI icons.\n    ");
    }
    var pathTags = paths_1.paths[iconName].map(function (item, index) {
        return (React.createElement("path", { fillRule: item.fillRule ? item.fillRule : undefined, fill: item.fill ? item.fill : null, key: index, "data-name": "" + iconName, d: "" + item.path }));
    });
    return (React.createElement(styles_1.StyledSvg, __assign({}, props, { role: "img", className: "ap-icon " + (className ? className : ''), width: getIconSize(iconSize), height: "100%", fill: iconColor, viewBox: "0 0 " + exports.iconSizes.viewBox + " " + exports.iconSizes.viewBox, preserveAspectRatio: "xMidYMid meet", x: "0", y: "0", id: iconName, ariaLabel: iconName }),
        React.createElement("path", { id: "background", fill: "none", d: "M0 0L24 0 24 24 0 24z" }),
        pathTags));
};
exports.ApIcon.defaultProps = {
    iconColor: theme_1.colors.grey4,
    iconSize: 'sm',
};
//# sourceMappingURL=ApIcon.js.map